export const CYBERPEDIA_URL =
  'https://www.cyberpilot.io/cyberpedia/new-platform-cyberpilot-app';
export const SECURITY_CULTURE_BOOK_DEMO =
  'https://meetings-eu1.hubspot.com/anders-winther/securityculture';
export const SECURITY_CULTURE_VIEW_SURVEY =
  'https://cyberpilot.typeform.com/to/TFbtURz4';
export const PHISHING_BOOK_DEMO_EN =
  'https://www.cyberpilot.io/book-phishing-demo-bpo?utm_campaign=86089933-Demos%20from%20app&utm_source=Demos%20from%20APP&utm_medium=Clicks%20on%20button%20in%20app';
export const PHISHING_BOOK_DEMO_DK =
  'https://www.cyberpilot.io/da/book-phishing-demo-bpo?utm_campaign=86089933-Demos%20from%20app&utm_source=Demos%20from%20APP&utm_medium=Clicks%20on%20button%20in%20app';
export const CYBERPEDIA_AD_AND_SSO_URL =
  'https://www.cyberpilot.io/cyberpedia/whitelisting-ad-integration-and-single-sign-on';
export const CYBERPEDIA_CLIENT_SECRET_UPDATE_URL =
  'https://www.cyberpilot.io/cyberpedia/update-entra-id-client-secret-in-cyberpilot-app';
export const PHISHING_WHITELISTING_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/whitelisting-overview-for-phishing-simulations';
export const ADMIN_TASK_WHITELISTING_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/email-whitelisting-guide';
export const OWN_MATERIALS_BOOK_DEMO = 'https://www.cyberpilot.io/meetings/tue';
export const AUTO_PHISHING_BOOK_DEMO_EN =
  'https://www.cyberpilot.io/book-phishing-demo-bpo';
export const AUTO_PHISHING_BOOK_DEMO_DK =
  'https://www.cyberpilot.io/da/book-phishing-demo-bpo';
export const INFORM_USERS_FOR_COLLABORATION_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/documents-for-starting-up';
export const TRAINING_PLANNER_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/set-up-course-schedules-with-the-training-planner';
export const BRANCHES_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/use-branches-to-group-your-users-and-simplify-administration#Branches';
export const GROUPS_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/use-branches-to-group-your-users-and-simplify-administration#Groups';
export const WHITELISTING_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/phishing-training#whitelisting';
export const MAIL_CONNECTOR_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/how-to-set-up-a-mail-connector';
export const COURSE_ACCESSIBILITY_GUIDE =
  'https://www.cyberpilot.io/cyberpedia/course-accessibility-features';

// Main dashboard links
export const AWT_BOOKING_URL_EN =
  'https://www.cyberpilot.io/book-demo-with-troels-awareness';
export const AWT_BOOKING_URL_DK =
  'https://www.cyberpilot.io/da/book-demo-with-troels-awareness';
export const PHISHING_BOOKING_URL_EN =
  'https://www.cyberpilot.io/book-phishing-demo-tja';
export const PHISHING_BOOKING_URL_DK =
  'https://www.cyberpilot.io/da/book-phishing-demo-jko';
export const SC_BOOKING_URL_EN =
  'https://www.cyberpilot.io/book-demo-with-troels-security-culture';
export const SC_BOOKING_URL_DK =
  'https://www.cyberpilot.io/da/book-demo-with-jan-security-culture';
export const SC_COMMUNICATION_TEMPLATE_URL =
  'https://www.cyberpilot.io/cyberpedia/email-templates-for-communicating-about-security-culture-surveys';
